import {
  borderRadius,
  CheckBox,
  customScrollMinimal,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export enum FilterGroups {
  Watchlist = 'watchlist',
  Provider = 'provider',
  Industries = 'industries',
  Countries = 'countries',
  AssetClasses = 'assetClasses',
}

export const SideAccordionFiltersRoot = styled.div`
  ${borderRadius.r2};
  border: 1px solid var(--border-soft);
  overflow: hidden;
`;

export const AccordionContentWrapper = styled.div`
  max-height: 160px;
  overflow-y: scroll;
  ${customScrollMinimal};

  > :not(:first-child) {
    margin-left: 8px;
  }
`;

export const StyledCheckbox = styled(CheckBox)`
  ${typographyV2.bodySm};

  [data-checkbox] {
    align-items: center;
  }

  [data-checkbox-label] {
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  [data-checkmark] {
    width: 14px;
    height: 14px;
  }
`;

export const SingleSelectedItem = styled.span`
  ${typographyV2.bodySm};
  color: var(--text-primary);
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 130px;
`;
